import React, { HTMLAttributes } from 'react'

import { cn } from '@/lib/utils'

type Props = HTMLAttributes<HTMLDivElement> & {
  isActive?: boolean
}

const FormGroup: React.FC<Props> = ({ className, ...props }) => (
  <div {...props} className={cn('mb-4 md:pb-2', className)} />
)

export default FormGroup
